import { render, staticRenderFns } from "./BaseContent.vue?vue&type=template&id=82faecd6&scoped=true&"
import script from "./BaseContent.vue?vue&type=script&lang=js&"
export * from "./BaseContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82faecd6",
  null
  
)

export default component.exports